// extracted by mini-css-extract-plugin
export default {"form":"grAvn","button":"Vc2My","info":"CxaRj","errorMessage":"qwabL","infoItem":"W9Mwu","infoText":"LnCNS","passwordIcon":"y22Mr"};